import React, { Fragment } from "react";
import { useTable, useResizeColumns } from "react-table";
import { Row, Col, Table, Spinner } from "react-bootstrap";
import Paging from "./Paging";
import { useFormContext } from "react-hook-form";
import { Tooltip } from "@mui/material";
const DataTable = ({ columns, data, config, redRows, yellowRows }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    prepareRow,
    rows, // Instead of using 'rows', we'll use page,
  } = useTable(
    {
      columns,
      data: data?.data ?? [],
      initialState: { pageIndex: 0 },
    },
    useResizeColumns,
  );
  const methods = useFormContext();

  return (
    <>
      <Row style={methods.formState.isSubmitting ? { opacity: "0.5" } : { opacity: "1" }}>
        <Col xs="12">
          {methods.formState.isSubmitting && (
            <div style={{ position: "absolute", top: "15rem", width: "100%", textAlign: "center", zIndex: "1000" }}>
              <Spinner animation="border" variant="primary" size={400} />
            </div>
          )}
          <div className="bg-white">
            <Table
              {...getTableProps()}
              hover responsive
              className="mt-1 border-bottom"
            >
              <thead className="border-bottom">
                {headerGroups.map((headerGroup) => {
                  const { key, ...res } = headerGroup.getHeaderGroupProps();
                  return <tr key={key} {...res}>
                    {headerGroup.headers.map((column) => {
                      const { key, ...res } = column.getHeaderProps({ style: { minWidth: column.minWidth, width: column.width, maxWidth: column.maxWidth, textAlign: column.align ?? "center" } })
                      return <th key={key}
                        {...res}>
                        {column.render("Header")}
                      </th>
                    })}
                  </tr>
                })}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                  prepareRow(row);
                  const { key, ...res } = row.getRowProps();
                  return (
                    <Tooltip
                      key={key}
                      arrow
                      followCursor
                      placement="top"
                      title={
                        redRows && redRows[i] ?
                          <div style={{ fontSize: 12 }}>{row.original?.redTooltip}</div>
                          : yellowRows && yellowRows[i] ? <div style={{ fontSize: 12 }}>{row.original?.yellowTooltip}</div> : undefined}
                    >
                      <tr
                        key={key}
                        {...res}
                      >
                        {row.cells.map((cell) => {
                          const { key, ...res } = cell.getCellProps({ className: cell.column.className, })
                          return (
                            <td
                              key={key}
                              {...res}
                              style={{
                                textAlign: cell.column.align ?? "center",
                                backgroundColor: redRows && redRows[i] ? "#fceded" : yellowRows && yellowRows[i] ? "rgba(255, 168, 0, 0.1)" : ""
                              }}
                            >
                              {cell.render("Cell")}
                            </td>
                          );
                        })}
                      </tr>
                    </Tooltip>
                  );
                })}
              </tbody>
              {config.show_footer &&
                <tfoot style={{ background: "linear-gradient(#dfe0eb,#bbbcc6)" }}>
                  {footerGroups.map(group => {
                    const { key, ...res } = group.getFooterGroupProps()
                    return (
                      <tr key={key} {...res}>
                        {group.headers.map(column => {
                          const { key, ...res } = column.getFooterProps({
                            style: {
                              textAlign: column.align || "center",
                              fontWeight: "bold"
                            }
                          })

                          return (
                            <td key={key} {...res}>{column.render('Footer')}</td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tfoot>}
            </Table>
            {
              config.show_pagination &&
              <Paging
                config={config}
                {...methods}
              />
            }
          </div>
        </Col>
      </Row>
    </>
  );
};

export default DataTable


